import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getPopupReasonString } from "../../../../AdminApi/commFunc";
import { getThousandComma } from "../../../../ApiTS/ApiCommonTS";
import { useApi } from "../../../../hooks/useApi";
import { TotalCount } from "../../../../pages/Users/UserInfo";
import LineBtn from "../../../Button/LineBtn";
import LineBox from "../../../DefaultStyles/LineBox";
import Loader from "../../../DefaultStyles/Loader";
import SpaceBetween from "../../../DefaultStyles/SpaceBetween";
import { OptionType } from "../../../Filters/DropDown";
import Pagination from "../../../Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../../Table/Table";
import PopupNotiInfoFilter from "./PopupNotiInfo/PopupNotiInfoFilter";
import PopupNotiModal from "./PopupNotiInfo/PopupNotiModal";

interface IPopupNoti {
  act: number;
  id: number;
  messg: number;
  name: string;
  nickname: string;
  reqDate: string;
  showDate: string;
  type: number;
  uid: string;
  writer: string;
  updateDate: string;
}

export interface IPopupNotiSave {
  user: string;
  id: number;
  act: number;
  writer: string;
  type: number;
  templateId: number;
  typeString: string;
  updateDate: string;
}

export default function PopupNotiInfo() {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [dropDownValue, setDropDownValue] = useState<OptionType>({
    value: "",
    label: "선택",
  });
  const [searchValue, setSearchValue] = useState<string | undefined>("");
  const [checkTemplateModal, setCheckTemplateModal] = useState(false);
  const [notiData, setNotiData] = useState<IPopupNotiSave>({
    user: "",
    id: 0,
    act: 0,
    writer: "",
    type: 0,
    templateId: 0,
    typeString: "",
    updateDate: "",
  });
  const [filter, setFilter] = useState({
    type: "",
    value: "",
  });

  const { response, loading, error, fetchData } = useApi({
    method: "get",
    url:
      `popup?page=${page}&size=10` +
      (searchValue !== "" ? `&${dropDownValue?.value}=${searchValue}` : ``) +
      (filter?.value !== "" ? `&${filter?.type}=${filter.value}` : ``),
  });

  // 팝업 사유 조회
  const {
    response: typeRes,
    error: typeError,
    loading: typeLoading,
    fetchData: typeFetchData,
  } = useApi({
    method: "get",
    url: response?.data?.items?.length > 0 ? `popup/type` : undefined,
  });

  const tableHead = [
    "No",
    "유저 정보",
    "팝업 사유",
    "마지막 팝업 노출일",
    "다음 팝업 노출일",
    "처리 여부",
    "등록자",
    "최종 수정일시",
    "템플릿 확인",
  ];

  const fetchDatas = () => {
    fetchData({
      method: "get",
      url: `popup?page=0&size=10`,
    });
    typeFetchData({
      method: "get",
      url: `popup/type`,
    });
  };

  useEffect(() => {
    if (error || typeError) {
      toast.error(
        typeError?.data ??
          error?.data ??
          "팝업 알림 현황을 조회하는 데에 실패하였습니다."
      );
    }
  }, [error, typeError]);

  return (
    <>
      <PopupNotiInfoFilter
        dropDownValue={dropDownValue}
        setDropDownValue={setDropDownValue}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        pageResetEvent={() => setPage(0)}
        setFilter={setFilter}
        fetchEvent={() => fetchDatas()}
      />

      <LineBox>
        <Table tableHeadData={tableHead}>
          <>
            {response?.data?.items?.map((d: IPopupNoti, i: number) => {
              return (
                <TableBody key={d?.id}>
                  <TableBodyItem>
                    {response?.data?.totalCount - (page * 10 + i)}
                  </TableBodyItem>
                  <TableBodyItem
                    clickable={true}
                    onClick={() => navigate(`/users/info/${d?.uid}`)}
                  >
                    {d?.uid}_{d?.name}_{d?.nickname}
                  </TableBodyItem>
                  <TableBodyItem>
                    {getPopupReasonString(d?.type, typeRes?.data)}
                  </TableBodyItem>
                  <TableBodyItem>
                    {d?.reqDate !== "" ? d?.reqDate : "-"}
                  </TableBodyItem>
                  <TableBodyItem>
                    {d?.showDate !== "" ? d?.showDate : "-"}
                  </TableBodyItem>
                  <TableBodyItem>
                    {d?.act === 1 ? "완료" : "미완료"}
                  </TableBodyItem>
                  <TableBodyItem>{d?.writer}</TableBodyItem>
                  <TableBodyItem>{d?.updateDate}</TableBodyItem>
                  <TableBodyItem>
                    <LineBtn
                      btnText="보기"
                      btnClickEvent={() => {
                        setCheckTemplateModal(true);
                        setNotiData({
                          act: d?.act,
                          id: d?.id,
                          templateId: d?.messg,
                          type: d?.type,
                          user: `${d?.uid}_${d?.name}_${d?.nickname}`,
                          writer: d?.writer,
                          typeString: getPopupReasonString(
                            d?.type,
                            typeRes?.data
                          ),
                          updateDate: d?.updateDate ?? "",
                        });
                      }}
                    />
                  </TableBodyItem>
                </TableBody>
              );
            })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      {(loading || typeLoading) && <Loader />}

      {checkTemplateModal && (
        <PopupNotiModal
          closeEvent={() => setCheckTemplateModal(false)}
          confirmEvent={() => fetchDatas()}
          type="view"
          popupData={notiData}
        />
      )}
    </>
  );
}
